module.exports = __webpack_public_path__ + "static/media/atomicdesign.d3322201.png";